<template>
  <div class="machine-service-signals-show service-visit-page">
    <KTCard ref="preview" v-bind:title="$t('MACHINE_SERVICE_SIGNALS.SHOW')">
      <template v-slot:title>
        <h3 class="card-label">
          <router-link :to="{ name: 'list-machine-service-signals' }">
            {{ $t("MACHINE_SERVICE_SIGNALS.TITLE") }}
          </router-link>
          <i class="mr-2"></i>
          <small>{{ $t("MACHINE_SERVICE_SIGNALS.SHOW") }}</small>
        </h3>
      </template>

      <template v-slot:toolbar>
        <div class="machine-service-signals-show__toolbar">
          <BackButton></BackButton>
        </div>
      </template>

      <template v-slot:body>
        <v-skeleton-loader
          v-if="firstLoader"
          :loading="firstLoader"
          type="article"
        ></v-skeleton-loader>

        <v-card v-else flat>
          <ul class="signal-details-list">
            <li>
              <strong>{{ $t("MACHINE_SERVICE_SIGNALS.DATE_TIME") }}:</strong>
              <span>{{ signal.dateTime }}</span>
            </li>
            <li>
              <strong>{{ $t("MACHINE_SERVICE_SIGNALS.MACHINE") }}:</strong>
              <span>{{ formatMachineName(signal.machine) }}</span>
            </li>
            <li>
              <strong>{{ $t("MACHINE_SERVICE_SIGNALS.STAFF") }}:</strong>
              <span>{{ signal.staff ? signal.staff.name : "-" }}</span>
            </li>
            <li class="signal-description-item">
              <strong>{{ $t("MACHINE_SERVICE_SIGNALS.DESCRIPTION") }}:</strong>
              <span class="signal-description-text">{{ signal.description }}</span>
            </li>
          </ul>
        </v-card>
      </template>
    </KTCard>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { FETCH_MACHINE_SERVICE_SIGNAL } from "@/modules/machine-service-signals/store/machine-service-signals.module";
import KTCard from "@/view/content/Card.vue";

export default {
  name: "MachineServiceSignalsShow",
  components: {
    KTCard
  },
  data() {
    return {
      firstLoader: true,
      signal: {}
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: this.$i18n.t("MACHINE_SERVICE_SIGNALS.TITLE"),
        route: { name: "list-machine-service-signals" }
      },
      { title: this.$i18n.t("MACHINE_SERVICE_SIGNALS.SHOW") }
    ]);
    this.getSignal();
  },
  methods: {
    getSignal() {
      this.$store
        .dispatch(FETCH_MACHINE_SERVICE_SIGNAL, this.$route.params.id)
        .then(data => {
          this.signal = data.data;
          this.firstLoader = false;
        })
        .catch(response => {
          if (response.status === 404) {
            this.$notify({
              group: "notify",
              type: "error",
              text: this.$i18n.t("MACHINE_SERVICE_SIGNALS.NOT_FOUND")
            });
            this.$router.push({ name: "list-machine-service-signals" });
          }
        });
    },
    formatMachineName(machine) {
      if (!machine) {
        return "";
      }

      if (machine.resource) {
        return machine.resource.name || machine.resource.serviceDisplayName || "";
      }

      return typeof machine === "string" ? machine : machine.name;
    }
  }
};
</script>

<style scoped>
.signal-details-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.signal-details-list li {
  align-items: center;
  display: flex;
  gap: 8px;
  margin-bottom: 12px;
  min-width: 0;
}

.signal-details-list li span {
  min-width: 0;
  overflow-wrap: anywhere;
}

.signal-description-item {
  align-items: flex-start !important;
  flex-direction: column;
}

.signal-description-text {
  white-space: pre-wrap;
}

@media (max-width: 767.98px) {
  .machine-service-signals-show__toolbar {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
